import { Notifications, NotificationsProps } from '@any-ui-react/notifications';

type ToasterProps = NotificationsProps;

export const Toaster = (props: ToasterProps) => {
  return <Notifications position="top-right" containerWidth={326} {...props} />;
};
